<template lang="pug">
  .height-100
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionEliminar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionEliminar = false"
        @do="validarEliminar"
        ref="confirmarEliminar"
      )
        span(slot="title") ¿Está seguro de guardar la fecha de nacimiento?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Eliminando...
          template(v-else)
            | Eliminar
        div.info-validar-eliminar(slot="information")
          template(v-if="empleadosValidados.length > 0")
            span No se puede eliminar el cargo ya que tiene empleados asociados:
            ul
              li(v-for="(o, index) in empleadosValidados" :key="index")
                span {{ o.nombre }}

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="lista_solicitudes")
        .contenedor-interno
          .title
            span Empleados sin Fecha de Nacimiento

          transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
            .body(key="body")
              .information
                template(v-if="lista.length > 0")
                  //- .is-desktop
                  table.table.is-striped.is-bordered
                    thead
                      th Empleado
                      th Fecha de Nacimiento
                      th.hide-break-1
                    tbody(
                      name="table-row"
                      is="transition-group"
                    )
                      tr.row-table(
                        v-for="(o,index) in lista"
                        :key="o+index+''"
                      )
                        td
                          span {{ o.nombre }}
                        td
                          .flex.fdc
                            //- el input devuelve formato 2024-04-01
                            input.input(
                              type="date",
                              v-model="o.fechaNacimiento"
                            )
                            .show-break-1.text-center.mt-5
                              button.button.is-small.is-primary(@click="guardarFechaNacimiento(o)")
                                span.icon.is-small
                                  i.fa.fa-save.is-small
                                span Guardar
                        td.text-center.hide-break-1
                          button.button.is-small.is-primary(@click="guardarFechaNacimiento(o)")
                            span.icon.is-small
                              i.fa.fa-save.is-small
                            span Guardar
                .is-loading(v-if="isLoading")
                  .icon
                    i.fa.fa-spinner.fa-spin
                div(v-if="lista.length === 0 && !isLoading")
                  .message.is-warning
                    .message-body No existen empleados sin fecha de nacimiento
</template>

<script>
import { apiGet, apiPut, notify } from '../util/general'
// import moment from 'moment'
export default {
  name: 'view_empleado_sin_nacimiento',
  data () {
    return {
      lista                 : []
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/empleado/sin-cumpleanios', {}, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardarFechaNacimiento (empleado) {
      var vm = this
      var obj = {
        codigo: empleado.codigo,
        fechaNacimiento: empleado.fechaNacimiento
      }
      apiPut(vm, '/empleado/cumpleanios', obj, function (data) {
        notify(vm, 'success', 'Exito', 'Fecha de nacimiento actualizada')
        vm.fetch();
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    guardarFechaNacimientoMasivo () {
      var vm = this
      var obj = {
        lista : vm.lista.map(function (o) {
          if (o.fechaNacimiento !== '') {
            return {
              codigo: o.codigo,
              fechaNacimiento: o.fechaNacimiento
            }
          }
        })
      }
      apiPut(vm, '/empleado/cumpleanios', obj, function (data) {
        notify(vm, 'success', 'Exito', 'Fecha de nacimiento actualizada')
        vm.fetch();
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px
  .lookup
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px
  .is-bold
    font-weight bold
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        // width 100%
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px




  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;
  .dias-pedidos
    font-size 12px
    color #9a9a9a

  .show-break-1
    display none

  @media (max-width 485px)
    .show-break-1
      display initial
    .hide-break-1
      display none

</style>



// WEBPACK FOOTER //
// View_Empleado_Sin_Nacimiento.vue?1ba70432